/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Container from "@/src/components/Container/Container";
import divorcePlannerImage from "@/src/assets/img/landingpage/Legalbird_Divorce_Planner.png";
import divorcePlannerSectionStyle from "./divorcePlannerSectionStyle";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

export type DivorcePlannerSectionProps = {
  header?: string;
  subheader?: string;
};
export const DivorcePlannerSection = ({
  header = "Ihr persönlicher Scheidungsplaner",
  subheader = "Jederzeit genau die Informationen, die Sie brauchen",
}: DivorcePlannerSectionProps) => {
  return (
    <Container sx={divorcePlannerSectionStyle.container}>
      <Typography component={"h2"} variant={"h3"} sx={divorcePlannerSectionStyle.heading} dangerouslySetInnerHTML={{ __html: header }} />
      <Typography component={"h3"} variant={"h4"} sx={divorcePlannerSectionStyle.subheading}>
        {subheader}
      </Typography>
      <Grid
        container
        sx={{
          alignItems: "center",
        }}
      >
        <Grid
          sx={divorcePlannerSectionStyle.divorceImageContainer}
          size={{
            xs: 12,
            sm: 6,
          }}
        >
          <Box component={"img"} src={divorcePlannerImage} alt="Scheidungsplaner Vorschau" sx={divorcePlannerSectionStyle.imgPhone} />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6,
          }}
        >
          <Box sx={divorcePlannerSectionStyle.text}>
            <Box sx={{ display: { xs: "none", md: "block" } }}>
              <Typography variant={"body2"}>
                Sie wollen wissen, wie es weiter geht und was Sie als Nächstes tun müssen? <br />
                <br />
                Bei Legalbird erhalten Sie einen interaktiven Scheidungsplaner mit allen Details zum Ablauf, Tipps und Checklisten - genau auf Ihre persönliche
                Situation ausgerichtet!
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default DivorcePlannerSection;
